import styled from "@emotion/styled";

export const Container = styled.div`
  max-width: 40rem;

  display: flex;
  flex-direction: column;
  align-items: stretch;

  button {
    margin-top: 1rem;
    align-self: center;
    text-transform: uppercase;
  }
`;
